module.exports = __webpack_public_path__ + "static/media/swimming.47ac9c94.mp4";